@if (allowAdd) {
  <div class="d-flex align-items-center mb-3">
    <textarea
      rows="3"
      class="form-control"
      [(ngModel)]="this.comment"
      [ngModelOptions]="{ standalone: true }"
    ></textarea>
    <button class="btn btn-primary" (click)="saveComments()">
      <i class="fa fa-plus"></i>&nbsp;<span i18n>Add Comment</span>
    </button>
  </div>
}

@for (comment of comments$ | async; track comment.id) {
  <div class="row">
    <div class="col">
      <div class="comment" [class.current-user]="isCurrentUser(comment)">
        <div class="comment-header d-flex align-items-center justify-content-between">
          <div class="d-flex">
            <span>{{ comment.userName }}</span>
            <span>{{ comment.date | date: 'shortDate' }} {{ comment.date | date: 'shortTime' }}</span>
          </div>
          @if (isCurrentUser(comment) || canAmendOtherComments()) {
            <div class="d-flex">
              <a (click)="edit(comment)"><i class="fa fa-pencil-alt" i18n-title title="Edit"></i></a>
              <a (click)="delete(comment.id)" i18n-title title="Delete"><i class="fa fa-trash-alt"></i></a>
            </div>
          }
        </div>
        <strong [innerHTML]="multiLineComment(comment.comment)"></strong>
      </div>
    </div>
  </div>
}
